module.exports = __webpack_public_path__ + "static/media/bombolulu_bedsitters2.ffb4397a.webp";